<script setup lang="ts">
import type { NavProps } from "~/types/nav.d"

defineProps<NavProps>()

const products = useProductVariantsStore()

const showSearch = ref(false)
</script>

<template>
  <nav
    id="navigation"
    class="navigation sticky left-4 top-0 h-full w-screen bg-[--theme-darkest] text-white backdrop-blur-sm sm:min-w-[14em] md:max-w-[24em] <md:flex <md:items-center <md:justify-center <md:pb-5"
  >
    <div class="flex flex-col items-center justify-center">
      <div v-if="!showSearch" class="flex size-full">
        <ULogo
          :product="products.activeProduct"
          aria-label="Gå tilbake kapitteloversikten"
          full-width
          small
          class="pt-12 <md:hidden"
          :dark="false"
        />
      </div>
      <div
        class="flex w-full items-center justify-center py-12"
        :class="{ '<md:hidden': !showSearch }"
      >
        <button
          v-if="showSearch"
          class="mr-2 size-12 flex-none rounded-full border-white p-2 md:hidden"
          @click="showSearch = false"
        >
          <UIcon
            class="ml-[3px] stroke-white text-white"
            name="close"
            size="sm"
          />
        </button>
        <USearchBar class="w-full" />
      </div>
    </div>

    <Transition name="fade" mode="out-in">
      <UNavList
        v-if="data.length"
        :data="data"
        :page-type="pageType"
        :folders="folders"
        class="h-fit w-full pb-24 md:h-[calc(85svh-6rem)] <md:hidden"
        :licence="licence"
      >
        <slot />
      </UNavList>
      <UNavListSkeleton v-else class="hidden md:block" />
    </Transition>
  </nav>
</template>

<!-- @apply mx-[-1.25rem] md:px-[1.25rem]; -->
<style scoped>
.navigation {
  @apply z-30;

  .top {
    @apply <md:grid <md:grid-cols-[max-content,1fr];
  }
}
.bottom {
  @apply absolute bottom-1 hidden py-5;
  @apply md:block;
}
</style>
